import { params } from '../../localData'
import i18nHandler from '../../i18n'

export function getOnboardingModel () {
  return {
    currStep: '0',
    locale: '',
    editMode: false,
    lastResponse: '',
    timeout: false,
    isMobile: false,
    isPartnerFlow: false,
    partnerToken: '',
    obFailureCode: 0,
    persistLastStep: '',
    isOwnershipPercentSliderTouched: false,
    isOwnershipPercentTextboxTouched: false,
    isPasswordSet: false,
    hasAccount: false,
    isMultiBusinessFlow: false,
    failedKycRoutes: [
      'checkDocs',
      'accountExists',
      'noBusinessDone',
      'noContinueDone',
      'noContinueChecking'
    ]
  }
}

export function getAdSource (self) {
  let adSource = self.$customerDetails.adSource
  // If adSource not false
  if (adSource) {
    try {
      // Parse adSource value to validate it not hold falsey string value EX. "null"
      adSource = JSON.parse(adSource)
    } catch (err) {
      // Guard it if value is not parsable
      adSource = ''
    }
  }
  // if adSource is falsey
  if (!adSource) {
    // Check if there is adSource value in localStorgae
    try {
      // If there is a value parse it
      adSource = JSON.parse(self.$storage.get('adSource'))
    } catch (err) {
      // Guard it if value is not parsable
      adSource = ''
    }
  }
  return adSource ? JSON.stringify(adSource) : '{}'
}

export function createErrorObject (errorCode, self) {
  // For default error message use field 'defaultError'
  let errorData = {
    errorCode,
    errorCodeName: '',
    field: '',
    content: '',
    isBusinessLogicError: false,
    isFailure: false,
    redirectUrl: ''
  }

  switch (errorCode.toString()) {
    // Postal Code

    // Show error code on confirmDetails screen
    case params.responseCodeEnums.INVALID_POSTAL:
      errorData.errorCodeName = 'INVALID_POSTAL'
      errorData.content = i18nHandler.t('validation.custom.postalCode.invalidFormat')
      errorData.field = 'checkbox'
      return errorData

    // PhoneNumber errors
    case params.responseCodeEnums.INVALID_PHONE_NUMBER:
      errorData.errorCodeName = 'INVALID_PHONE_NUMBER'
      errorData.content = i18nHandler.t('validation.custom.phoneNumber.phoneNumber')
      errorData.field = 'phoneNumber'
      return errorData

    case params.responseCodeEnums.PHONE_NUMBER_VOIP:
      errorData.errorCodeName = 'PHONE_NUMBER_VOIP'
      errorData.content = i18nHandler.t('errors.voip')
      errorData.field = 'phoneNumber'
      return errorData

    case params.responseCodeEnums.PHONE_NUMBER_LANDLINE:
      errorData.errorCodeName = 'PHONE_NUMBER_LANDLINE'
      errorData.content = i18nHandler.t('errors.landline')
      errorData.field = 'phoneNumber'
      return errorData

    case params.responseCodeEnums.PHONE_NUMBER_NOT_US:
      errorData.errorCodeName = 'PHONE_NUMBER_NOT_US'
      errorData.content = i18nHandler.t('errors.notUsNumber')
      errorData.field = 'phoneNumber'
      return errorData

    case params.responseCodeEnums.NEW_PHONE_EXISTS:
      errorData.errorCodeName = 'NEW_PHONE_EXISTS'
      errorData.content = i18nHandler.t('validation.custom.phoneNumber.exists')
      errorData.field = 'phoneNumber'
      return errorData

    // ----------------------
    // Email errors

    case params.responseCodeEnums.EMAIL_ALREADY_EXISTS:
      errorData.errorCodeName = 'EMAIL_ALREADY_EXISTS'
      // errorData.content = i18nHandler.t('validation.custom.email.exists')
      errorData.field = ''
      return errorData

    case params.responseCodeEnums.UBO_EMAIL_ALREADY_EXISTS:
      errorData.errorCodeName = 'UBO_EMAIL_ALREADY_EXISTS'
      errorData.content = 'This email already have a Lili account. Please try using a different email for this owner'
      errorData.field = 'email'
      return errorData

    case params.responseCodeEnums.EMAIL_CHANGE_IS_NOT_ALLOWED:
      errorData.errorCodeName = 'EMAIL_CHANGE_IS_NOT_ALLOWED'
      errorData.content = 'Email change is not allowed'
      errorData.field = 'email'
      return errorData

    case params.responseCodeEnums.INVALID_EMAIL_FORMAT:
      errorData.errorCodeName = 'INVALID_EMAIL_FORMAT'
      errorData.content = i18nHandler.t('validation.custom.email.email')
      errorData.field = 'email'
      return errorData

    // ---------------------
    // FirstName errors
    case params.responseCodeEnums.INVALID_FIRST_NAME:
      errorData.errorCodeName = 'INVALID_FIRST_NAME'
      errorData.content = i18nHandler.t('validation.custom.firstName.name')
      errorData.field = 'firstName'
      return errorData
    // -------------------
    // LastName errors
    case params.responseCodeEnums.INVALID_LAST_NAME:
      errorData.errorCodeName = 'INVALID_LAST_NAME'
      errorData.content = i18nHandler.t('validation.custom.lastName.name')
      errorData.field = 'lastName'
      return errorData
    // -------------------
    // Referral errors
    case params.responseCodeEnums.REFERRAL_CODE_EXPIRE:
      errorData.errorCodeName = 'REFERRAL_CODE_EXPIRE'
      errorData.content = i18nHandler.t('validation.custom.referral.expired')
      errorData.field = 'referral'
      return errorData
    case params.responseCodeEnums.INVALID_REFERRAL_CODE:
      errorData.errorCodeName = 'INVALID_REFERRAL_CODE'
      errorData.content = i18nHandler.t('validation.custom.referral.invalid')
      errorData.field = 'referral'
      return errorData
    // -------------------
    // SSN errors
    case params.responseCodeEnums.INVALID_SSN_FORMAT:
      errorData.errorCodeName = 'INVALID_SSN_FORMAT'
      errorData.content = i18nHandler.t('validation.custom.ssn.invalidFormat')
      errorData.field = 'ssn'
      return errorData
    case params.responseCodeEnums.SSN_ALREADY_EXISTS:
      errorData.errorCodeName = 'SSN_ALREADY_EXISTS'
      errorData.content = i18nHandler.t('validation.custom.ssn.duplicate')
      errorData.field = 'ssn'
      return errorData
    // -------------------
    // BirthDate errors
    case params.responseCodeEnums.MUST_BE_OLDER_THAN:
      errorData.errorCodeName = 'MUST_BE_OLDER_THAN'
      errorData.content = i18nHandler.t('validation.custom.birthDate.tooYoung')
      errorData.field = 'birthDate'
      return errorData
    case params.responseCodeEnums.INCORRECT_AGE:
      errorData.errorCodeName = 'INCORRECT_AGE'
      errorData.content = i18nHandler.t('validation.custom.birthDate.date_format')
      errorData.field = 'birthDate'
      return errorData
    // -------------------
    // Password errors
    case params.responseCodeEnums.INCORRECT_USER_PASSWORD_FOR_BROWSER:
      errorData.errorCodeName = 'INCORRECT_USER_PASSWORD_FOR_BROWSER'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.PASSWORD_ILLEGAL_SEQUENCE:
      errorData.errorCodeName = 'PASSWORD_ILLEGAL_SEQUENCE'
      errorData.content = i18nHandler.t('password.req10')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.PASSWORD_TOO_SHORT:
      errorData.errorCodeName = 'PASSWORD_TOO_SHORT'
      errorData.content = i18nHandler.t('password.req1')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.INVALID_PASSWORD_FORMAT:
      errorData.errorCodeName = 'INVALID_PASSWORD_FORMAT'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.PASSWORD_ILLEGAL_REPEAT:
      errorData.errorCodeName = 'PASSWORD_ILLEGAL_REPEAT'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.PASSWORD_TOO_LONG:
      errorData.errorCodeName = 'INVALID_PASSWORD_FORMAT'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.INCORRECT_USER_PASSWORD:
      errorData.errorCodeName = 'INCORRECT_USER_PASSWORD'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.PASSWORD_ILLEGAL_NUMERIC:
      errorData.errorCodeName = 'PASSWORD_ILLEGAL_NUMERIC'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData
    case params.responseCodeEnums.USER_LOCKED:
      errorData.errorCodeName = 'USER_LOCKED'
      errorData.content = i18nHandler.t('validation.custom.pinCode.locked')
      errorData.field = 'password'
      // Show user message
      self.$store.commit('errors/updateUserMessage', {
        isActive: false,
        popupType: ''
      })
      setTimeout(() => {
        self.$store.commit('errors/updateUserMessage', {
          isActive: true,
          popupType: 'UserLocked'
        })
      }, 10)

      return errorData
    case params.responseCodeEnums.MFA_CODE_IS_INVALID:
      errorData.errorCodeName = 'MFA_CODE_IS_INVALID'
      errorData.content = i18nHandler.t('errors.badPasswordToken')
      errorData.field = 'password'
      return errorData

    // Address Cases

    case params.responseCodeEnums.INVALID_LINE1:
      errorData.errorCodeName = 'INVALID_LINE1'
      errorData.content = i18nHandler.t('validation.custom.line1.regex')
      errorData.field = 'line1'
      return errorData

    case params.responseCodeEnums.INVALID_CITY:
      errorData.errorCodeName = 'INVALID_CITY'
      errorData.content = i18nHandler.t('validation.custom.city.format')
      errorData.field = 'city'
      return errorData

    case params.responseCodeEnums.INVALID_LINE1_PO_BOX:
      errorData.errorCodeName = 'INVALID_LINE1_PO_BOX'
      errorData.content = 'A P.O. Box cannot be used as your Home Address'
      errorData.field = 'line1'
      return errorData

    case params.responseCodeEnums.BUSINESS_ADDRESS_AGENT:
      errorData.errorCodeName = 'BUSINESS_ADDRESS_AGENT'
      errorData.content = 'It appears that you entered a registered agent address. Please enter the address from which your business operates.'
      errorData.field = 'line1'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT_ADDRESS_PO_BOX'
      errorData.content = 'A P.O. Box cannot be used as your Home Address'
      errorData.field = 'checkbox'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT_ADDRESS_UNADDRESSABLE'
      errorData.content = 'Please enter an address serviceable by USPS'
      errorData.field = 'checkbox'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT_ADDRESS_PARTNER:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT_ADDRESS_PARTNER'
      errorData.content = 'Please validate additional business owner home address is personal and not commercial'
      errorData.field = 'checkbox'
      return errorData

    case params.responseCodeEnums.INVALID_LINE2:
      errorData.errorCodeName = 'INVALID_LINE2'
      errorData.content = i18nHandler.t('validation.custom.line1.regex')
      errorData.field = 'line2'
      return errorData

    // Business page

    case params.responseCodeEnums.BUSINESS_NAME_ILLEGAL_NAME:
      errorData.errorCodeName = 'BUSINESS_NAME_ILLEGAL_NAME'
      errorData.content = 'Business name contain invalid characters e.g. : ׳ > % # " ; '
      errorData.field = 'businessName'
      return errorData

    case params.responseCodeEnums.LLC_INVALID_EIN:
      errorData.errorCodeName = 'LLC_INVALID_EIN'
      errorData.content = 'EIN number is not valid, please compare to your IRS document *'
      errorData.field = 'ein'
      return errorData

    case params.responseCodeEnums.EIN_IS_NOT_SSN:
      errorData.errorCodeName = 'EIN_IS_NOT_SSN'
      errorData.content = 'EIN is not an SSN. If you don\'t have EIN, you can choose a different business type'
      errorData.field = 'ein'
      return errorData

    case params.responseCodeEnums.EIN_ALREADY_EXISTS:
      errorData.errorCodeName = 'EIN_ALREADY_EXISTS'
      errorData.content = 'Sorry, something went wrong, please verify number is matching your IRS record'
      errorData.field = 'ein'
      return errorData

    case params.responseCodeEnums.EIN_NOT_UNIQUE:
      errorData.errorCodeName = 'EIN_NOT_UNIQUE'
      errorData.content = 'We’re sorry we can’t open account for this ein number'
      errorData.field = 'ein'
      return errorData

    case params.responseCodeEnums.LLC_INVALID_STATE:
      errorData.errorCodeName = 'LLC_INVALID_STATE'
      errorData.content = 'Invalid state'
      errorData.field = 'registeredState'
      return errorData

    // Token Expired
    case params.responseCodeEnums.tokenExpired:
      errorData.errorCodeName = 'TOKEN_EXPIRED'
      errorData.content = 'Token expired, user will redirect to home page'
      errorData.field = 'TokenExpire'
      errorData.isBusinessLogicError = true
      return errorData

    // Failed KYC no redirect - resubmit

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT_ADDRESS:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT_ADDRESS'
      errorData.content = i18nHandler.t('validation.custom.checkbox.failedKycAddress')
      errorData.field = 'checkbox'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT_ADDRESS_COMMERCIAL'
      errorData.content = 'Please enter your personal not business address'
      errorData.field = 'checkbox'
      return errorData

    // Owner Percent %

    case params.responseCodeEnums.OWNERSHIP_PERCENT_NOT_VALID:
      errorData.errorCodeName = 'OWNERSHIP_PERCENT_NOT_VALID'
      errorData.content = 'Total ownership percentage exceeds 100%'
      errorData.field = 'percentOwned'
      return errorData

    // Failed KYC no redirect

    case params.responseCodeEnums.FAILED_KYC_RESUBMIT:
      errorData.errorCodeName = 'FAILED_KYC_RESUBMIT'
      errorData.content = i18nHandler.t('validation.custom.checkbox.failedKyc')
      errorData.field = 'checkbox'
      return errorData

    // ** Redirect failures errors **

    case params.responseCodeEnums.USER_INCORRECT_STATE:
      errorData.errorCodeName = 'USER_INCORRECT_STATE'
      errorData.content = i18nHandler.t('validation.custom.checkbox.failedKyc')
      errorData.isFailure = true
      errorData.redirectUrl = '/index.html'
      errorData.field = 'email'
      errorData.isBusinessLogicError = true
      return errorData

    case params.responseCodeEnums.FAILED_KYC_PARTNER:
      errorData.errorCodeName = 'FAILED_KYC'
      errorData.isFailure = true
      errorData.redirectUrl = '/partner/noContinueDone'
      return errorData

    case params.responseCodeEnums.FAILED_KYC:
      errorData.errorCodeName = 'FAILED_KYC'
      errorData.isFailure = true
      errorData.redirectUrl = '/partner/noContinueDone'
      return errorData

    case params.responseCodeEnums.NAME_TOO_LONG:
      errorData.errorCodeName = 'NAME_TOO_LONG'
      errorData.isFailure = true
      errorData.redirectUrl = '/partner/debitCardName'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_CHECKING:
      errorData.errorCodeName = 'FAILED_KYC_CHECKING'
      errorData.isFailure = true
      errorData.redirectUrl = '/partner/noContinueChecking'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_MORE_INFO:
      errorData.errorCodeName = 'FAILED_KYC_MORE_INFO'
      errorData.isFailure = true
      errorData.redirectUrl = '/partner/checkDocs'
      return errorData

    case params.responseCodeEnums.FAILED_KYC_MORE_INFO_AUTO:
      errorData.errorCodeName = 'FAILED_KYC_MORE_INFO_AUTO'
      errorData.isFailure = true
      errorData.isBusinessLogicError = false
      errorData.redirectUrl = '/partner/checkDocs'
      return errorData

    case params.responseCodeEnums.CUSTOMER_ALREADY_REGISTER:
      errorData.errorCodeName = 'CUSTOMER_ALREADY_REGISTER'
      errorData.isFailure = true
      errorData.isBusinessLogicError = false
      errorData.redirectUrl = '/partner/alreadyHaveAccount'
      return errorData

    case params.responseCodeEnums.CUSTOMER_LEAD_NOT_FOUND:
      errorData.errorCodeName = 'CUSTOMER_LEAD_NOT_FOUND'
      errorData.isFailure = true
      errorData.isBusinessLogicError = false
      errorData.redirectUrl = '/index.html'
      return errorData
    // ----------------------

    default:
      errorData.errorCodeName = 'defaultError'
      errorData.content = i18nHandler.t('errors.oops')
      errorData.field = 'defaultError'
      errorData.isBusinessLogicError = true
      return errorData
  }
}



// WEBPACK FOOTER //
// ./src/services/entities/onboardingService.js